/*
Валидаторы используются в инпутах,
должен быть массивом из массивов [регулярка, текст ошибки]
или функцией, возвращающей ошибку
*/

const minLength = l => v => v && v.length < l && `Минимум символов: ${l}`;
const maxLength = l => v => v.length > l && `Максимум символов: ${l}`;
const checkSymbols = (v, regex = /^[а-яё _-]+$/i) => v && !v.match(regex) && 'Некорректные символы. Используйте кириллицу и знак "-"';
const required = (v, error = 'Обязательное поле') => !v.length && error;
const monthInvalid = (m, date) => (!m || m > 12 || m < 1 || (new Date(date)).getMonth() + 1 !== Number(m));
const checkDate = v => {
    const [d, m, y] = v.split('.');
    if ((!d || d > 31 || d < 1)
        || monthInvalid(m,`${m} ${d} ${y}`)
        || (!y || y < 1900 || y > (new Date).getFullYear())) {
        return 'Неверная дата';
    } return '';
};
const checkUnderage = v => {
    const [d, m, y] = v.split('.');
    return Math.floor((Date.now() - new Date(`${m} ${d} ${y}`).getTime()) / 31536000000) > 18
            && 'Ребёнок - до 18 лет';
}
const numbersOnly = (v, error = 'Используйте цифры') => v && !v.match(/^[0-9]*$/) && error;

export default {
    email: [
        v => !v.length ? 'Укажите Email' : '',
        [/^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9-]+\.)+([a-zA-Z0-9-]){2,}$/, 'Некорректный Email'], // не менять сортировку! регуларка используется в других местах
        v => v.length < 5 ? 'Минимальное количество символов: 5' : '',
        v => v.length > 129 ? 'Максимальное количество символов: 129' : '',
    ],
    required: [required],
    phone: [
      v => required(v, 'Укажите телефон'),
      v => v.replace(/\D/g, '').length !== 11 ? 'Некорректный номер телефона' : ''
    ],
    name: [ // ФИО
        v => required(v, 'Укажите Имя'),
        minLength(2),
        maxLength(64),
        checkSymbols,
    ],
    surname: [
        minLength(2),
        maxLength(64),
        checkSymbols
    ],
    date: [
        checkDate
    ],
    child_date: [
        checkDate,
        checkUnderage
    ],
    code: [ // Код подтверждения sms/email
        [/^[0-9]*$/, 'Код должен содержать только цифры'],
        [/^[0-9]{6}$/, 'Код должен состоять из 6 символов'],
    ],
    postal_сode: [ // Индекс
        numbersOnly,
        maxLength(6),
    ],
    street: [ // Улица
      v => required(v, 'Укажите название улицы'),
      [/^[0-9а-яё :;.,/\\-]*$/i, 'Некорректные символы'],
      maxLength(200),
    ],
    house: [
      v => required(v, 'Укажите номер дома'),
      [/^[0-9а-яё :;.,/\\-]*$/i, 'Некорректные символы'],
      maxLength(50),
    ],
    address_name: [
      v => required(v, 'Укажите название для адреса'),
    ],
    address_detail: [ // Дом, Корпус, Квартира, Строение
        [/^[./0-9а-яё _-]*$/i, 'Используйте кириллицу'],
        maxLength(10),
    ],
    entrance: [ // Подъезд
        numbersOnly,
        maxLength(10),
    ],
    floor: [ // Этаж
        numbersOnly,
        maxLength(3),
    ],
    postalCode: [
        numbersOnly,
        v => {
            if (v.length && v.length !== 6) {
                return 'Должен содержать 6 цифр'
            }
        },
    ],
}
